import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { PrintModalPropsTypes } from "../../../../../Types/Application/Contacts";
import { Cancel, Print, PrintViews } from "../../../../../utils/Constant";
import { H5, H6, Image, P } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Service'
import { EmailAddress, General } from '../../../../../utils/Constant'
const PrintModalPreview = ({ printModal, selectedUser, toggleCallback }: PrintModalPropsTypes) => {
  const printModalToggle = () => {
    toggleCallback(false);
  };
  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({contentRef});
  return (
    <Modal fade className="modal-bookmark" isOpen={printModal} toggle={printModalToggle} centered>
      <ModalHeader toggle={printModalToggle}>{PrintViews}</ModalHeader>
      <ModalBody className="list-persons">
      <div className="profile-mail pt-0" id="DivIdToPrint" ref={contentRef}>
        <div className="d-flex">
            <Image className= 'img-100 img-fluid m-r-20 rounded-circle' src= {dynamicImage(selectedUser.avatar)} alt= 'users' />
            <div className="flex-grow-1 mt-0">
                <H5>
                  <span id="printname">{selectedUser.name}</span>
                  <span id="printlast">{selectedUser.sureName}</span>
                </H5>
                <P>{selectedUser.email}</P>
            </div >
            </div>
            <div className="email-general">
            <H6>{General}</H6>
            <P>{EmailAddress}:<span className="font-primary" id="mailadd">{selectedUser.email}</span></P>
        </div>
      </div>
        <Btn color="secondary" className="me-1" onClick={() => handlePrint()}>
          {Print}
        </Btn>
        <Btn color="primary" onClick={printModalToggle}>
          {Cancel}
        </Btn>
      </ModalBody>
    </Modal>
  );
};

export default PrintModalPreview;
